import { FormlyFieldConfig } from "@ngx-formly/core";
import { FieldDefinitionConditions } from "../../../../../../sections/medicinalProduct/message/fieldDefinition-conditions";
import { FieldDefinitionFields } from "../../../../../../sections/medicinalProduct/message/fieldDefinition-fields";
import { Injector } from "@angular/core";
import { EntityEnum } from "../../../EntityEnum";
import { MedicinalProductsQueryNode } from "../../MedicinalProductsQueryNode";
import { Art57Section } from "../../../../Art57Section/Art57Section";
import { AutoUploadEntityEnum as AutoUploadEntityEnum } from "../../../../AutoUploadEntityEnum";
import { TreeNodeOrganisationList } from "../../../Art57Node/ListEntity/TreeNodeOrganisationList";

export class SponsorQueryNode extends MedicinalProductsQueryNode {
    constructor(injector: Injector) {
    const queryFields: FormlyFieldConfig[] =  new FieldDefinitionFields(injector).sponsorFields;
    const createChidTemplateParams = {nodeType: 2};
    const queryConditions: FormlyFieldConfig[] = new FieldDefinitionConditions(injector).sponsorConditions;
       super(injector, [], 'Sponsors', EntityEnum.sponsor,  queryFields, queryConditions, injector.get(Art57Section).medicinalProduct.sponsorTreeNode,TreeNodeOrganisationList,AutoUploadEntityEnum.sponsor,createChidTemplateParams);
       
    }
}